import { cn, formatPercent } from "@pma/utils/helpers"

// ---------------------------------------------------------------------------
// CompletionBar — progress bar with percentage label
// ---------------------------------------------------------------------------

export interface CompletionBarProps {
  percent: number
}

export function CompletionBar({ percent }: CompletionBarProps) {
  const color =
    percent >= 75 ? "bg-green-500" : percent >= 40 ? "bg-amber-500" : percent > 0 ? "bg-red-400" : "bg-gray-200"

  return (
    <div className="flex items-center gap-2 min-w-[120px]">
      <div className="relative h-2 flex-1 rounded-full bg-gray-100 overflow-hidden">
        <div
          className={cn("h-full rounded-full transition-all duration-500", color)}
          style={{ width: `${Math.min(percent, 100)}%` }}
        />
      </div>
      <span className="font-mono text-xs font-semibold tabular-nums text-gray-700 w-10 text-end">
        {formatPercent(percent)}
      </span>
    </div>
  )
}
